import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const DownloadIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z"
        fill="#676767"
      />
    </SvgIcon>
  );
};

export default memo(DownloadIcon);
